import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginFormComponent } from './pages/autenticacao/login-form/login-form.component';
import { ResetPasswordFormComponent } from './pages/autenticacao/reset-password-form/reset-password-form.component';
import { CreateAccountFormComponent } from './pages/autenticacao/create-account-form/create-account-form.component';
import { ChangePasswordFormComponent } from './pages/autenticacao/change-password-form/change-password-form.component';
import { AuthGuardService, AuthGuardServiceAcesso, AuthGuardServiceLoginForm, RedirectGuard } from './shared/services/auth.service';
import { ConstantsRotasDoSistema } from './shared/constants/constants-rotas-do-sistema';

const routes: Routes = [
    {
        path: ConstantsRotasDoSistema.LOGIN,
        component: LoginFormComponent,
        canActivate: [AuthGuardServiceLoginForm]
    },
    {
        path: ConstantsRotasDoSistema.RESET_PASSWORD,
        component: ResetPasswordFormComponent,
        canActivate: [AuthGuardServiceLoginForm]
    },
    {
        path: 'create-account',
        component: CreateAccountFormComponent,
        canActivate: [AuthGuardServiceLoginForm]
    },
    {
        path: ConstantsRotasDoSistema.ALTERAR_SENHA + '/:token',
        component: ChangePasswordFormComponent,
        canActivate: [AuthGuardServiceLoginForm]
    },
    {
        path: '',
        pathMatch: 'full',
        canActivate: [AuthGuardService, RedirectGuard]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [
        AuthGuardServiceLoginForm,
        AuthGuardService
    ]
})
export class AppRoutingModule { }
